
import CheatSheet from './cheatsheet/cheatsheet.js';
import ComponentsCheatSheet from './cheatsheet/components-cheatsheet.js';

export default [
	CheatSheet,
	ComponentsCheatSheet
];
